import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "17",
  viewBox: "0 0 20 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.9684 1.23591L16.3255 14.5284C16.1541 15.1545 15.3613 15.477 14.7113 15.1798L10.1041 13.074L7.92555 16.2295C7.33269 17.0896 5.83269 16.7165 5.83269 15.711V12.195C5.83269 11.9231 5.96126 11.6638 6.18269 11.4741L15.1613 3.88556C15.1541 3.79071 15.0398 3.7085 14.9255 3.77806L4.21126 10.3801L0.611261 8.73588C-0.231596 8.35013 -0.195882 7.26877 0.675547 6.93361L18.4255 0.0849842C19.2755 -0.243851 20.1898 0.432791 19.9684 1.23591Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }